import FindMateIcon from "@assets/images/activity-board/find-mate.svg";
import WordPuzzlesIcon from "@assets/images/activity-board/word-puzzles.svg";
import ScoreHuntIcon from "@assets/images/activity-board/score-hunt.svg";
import GuessPictureIcon from "@assets/images/activity-board/guess-picture.svg";
import LuckyWheelIcon from "@assets/images/activity-board/lucky-wheel.svg";
import WhoWantsScoreIcon from "@assets/images/activity-board/who-wants-score.svg";
import BestPlateIcon from "@assets/images/activity-board/best-plate.svg";

/**
 * Oyunların ana sayfadaki varsayılan ikonları (Oyunlar bölümü ve Aktivite Board). Board'da oyun
 * tanımında "Simge" yüklüyse o, yoksa bunlar kullanılır.
 */
export const GAME_ICONS = {
  FIND_MATE: FindMateIcon,
  WORD_PUZZLES: WordPuzzlesIcon,
  SCORE_HUNT: ScoreHuntIcon,
  GUESS_PICTURE: GuessPictureIcon,
  LUCKY_WHEEL: LuckyWheelIcon,
  WHO_WANTS_SCORE: WhoWantsScoreIcon,
  BEST_PLATE: BestPlateIcon,
};
